/********************************************************************************
 * Copyright (c) 2020 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/

import { FunctionComponent } from 'react';
import Box from '@mui/material/Box';
import { SanitizedMarkdown } from 'openvsx-webui/lib/components/sanitized-markdown';
import { DelayedLoadIndicator } from 'openvsx-webui/lib/components/delayed-load-indicator';
import { useDocument } from './use-document';

export const Document: FunctionComponent<DocumentProps> = (props) => {
  const { data: content, isPending } = useDocument(props.url);

  return (
    <Box p={5} display='flex' width='100%' justifyContent='center'>
      <DelayedLoadIndicator loading={isPending} />
      <Box maxWidth='1040px'>{content ? <SanitizedMarkdown content={content} /> : null}</Box>
    </Box>
  );
};

export interface DocumentProps {
  url: string;
}
